import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class SfCompanyProvider {

  private _service: string = 'payroll';
  private _model: string = 'SFCompany';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getemppayrolldata(
      periodCode: string, empStatus: string, gender: string,
      religion: string, marital: string, skip: number, limit: number,
      worklocationCode: string, searchByFullName?: string): Observable<any> {

    const _method: string = 'GET';
    const _func: string = 'getemppayrolldata';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof empStatus !== 'undefined' && empStatus !== null) _urlParams.empStatus = empStatus;
    if (typeof gender !== 'undefined' && gender !== null) _urlParams.gender = gender;
    if (typeof religion !== 'undefined' && religion !== null) _urlParams.religion = religion;
    if (typeof marital !== 'undefined' && marital !== null) _urlParams.marital = marital;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof worklocationCode !== 'undefined' && worklocationCode !== null) _urlParams.worklocation = worklocationCode;
    if (typeof searchByFullName !== 'undefined' && searchByFullName !== null) _urlParams.search = searchByFullName;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getCompany(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getCompany';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getActiveAllEmployee(periodCode: any = {}, payDate: any = {}, search: any = {},
                              filters: any = {}, skip: any = {}, limit: any = {}): Observable<any> {

    const _method: string = 'GET';
    const _func: string = 'getActiveAllEmployee';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;
    if (typeof search !== 'undefined' && search !== null) _urlParams.search = search;
    if (typeof filters !== 'undefined' && filters !== null) _urlParams.filters = filters;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public bankName(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getBank';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getFeed(params: any = {}): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getFeed';
    const _params: any = {};
    const _urlParams = {
      params: []
    };
    const _body: any = {};

    _urlParams.params = params;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public downloadFileByName(fileName: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadFileByName';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof fileName !== 'undefined' && fileName !== null) _urlParams.fileName = fileName;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public getFormulaComponent(empId: string): Observable<any> {

    const _method: string = 'GET';
    const _func: string = 'getFormulaComponent';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getWorklocation(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getWorklocation';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }
  
  public marketplacetoken(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'marketplacetoken';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }
  
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-company/sf-company.ts